/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAttributes200ResponseAllOf
 */
export interface GetAttributes200ResponseAllOf {
    /**
     * Attributes divided into named buckets. Bucket names are top level keys; attributes are values. Attributes consist of key-value pairs. Attribute names (keys) may be at most 70 bytes long. Attribute values must be JSON-serializable and are limited to 64KiB.
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof GetAttributes200ResponseAllOf
     */
    result?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Check if a given object implements the GetAttributes200ResponseAllOf interface.
 */
export function instanceOfGetAttributes200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAttributes200ResponseAllOfFromJSON(json: any): GetAttributes200ResponseAllOf {
    return GetAttributes200ResponseAllOfFromJSONTyped(json, false);
}

export function GetAttributes200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttributes200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetAttributes200ResponseAllOfToJSON(value?: GetAttributes200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

